import React from 'react'
import css from '@emotion/css'
import classNames from 'classnames'

import { mq } from '../css/style'

const Sound = ({ isSoundOn, handleSoundClick }) => {
    return (
        <div
            className={classNames(
                'sprite',
                'Composition-2_106',
                { 'is-on': isSoundOn === false },
                { 'is-off': isSoundOn === true }
            )}
            css={soundClass}
            onClick={handleSoundClick}
        />
    )
}

const soundClass = css`
    display: none;
    margin-right: -10px;

    ${mq.small(css`
        display: block;
    `)}
`

export default Sound
